import React from 'react'
import _ from 'lodash'
import GatsbyLink from 'gatsby-link'
import { withRouter } from 'react-router-dom'
import * as Paths from '../constants/Paths'

class Link extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {

    var { to, toPath, href, children, rr = false, className = "", onClick = _.noop } = this.props;
    if (href) { to = href }
    if (!to) return null;

    const passedProps = {className};

    if(to.startsWith('http')) {
      return (<a href={to} target="_blank" {...passedProps}>{children}</a>);
    } else {
      return (<GatsbyLink to={to} {...passedProps}>{children}</GatsbyLink>)
    }

  }

  onReactRouterClick(e, to) {
    e.preventDefault();
    this.props.history.push(to);
  }

}

export default withRouter(Link)



// WEBPACK FOOTER //
// ./src/components/Link.js